import React from 'react';

export const REQIcon = () => {
  return (
    <div>
      <img src="/pictures/REQIcon.svg" alt="" />
    </div>
  );
};
